import { render } from "./ModificacionDetalle.vue?vue&type=template&id=7efc97dc"
import script from "./ModificacionDetalle.vue?vue&type=script&lang=js"
export * from "./ModificacionDetalle.vue?vue&type=script&lang=js"

import "../formulario.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__